import * as React from "react"
import {
  Modal,
  ModalCard,
  StyledModal,
  StyledModalBody,
  StyledModalActions,
  Button,
  StyledModalHeader,
} from "gatsby-interface"
import { ModalMessage } from "@modules/modal"
import { Text } from "./shared/Text"
import {
  ui as uiText,
  gatsbyCloudCdnIntegrationConfig as text,
} from "@modules/locales/default.json"
import { interpolateMessage } from "@modules/locales"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"

export type DisableCloudCdnFormProps = {
  siteName: string
  onDismiss: () => void
  onDisable: () => void
  disableRequested: boolean
}

export function DisableCloudCdnForm({
  siteName,
  onDismiss,
  onDisable,
  disableRequested,
}: DisableCloudCdnFormProps) {
  const [setError, errorAlert] = useTriggerErrorAlert()

  const handleDisable = async () => {
    try {
      onDisable()
      onDismiss()
    } catch (error) {
      setError(error)
    }
  }

  return (
    <Modal
      isOpen={disableRequested}
      aria-label={text.messages.doYouWantToTurnOffGatsbyCloudCDN}
      onDismiss={onDismiss}
      type="error"
    >
      <ModalCard>
        <StyledModal variant="WARNING">
          <StyledModalHeader onCloseButtonClick={onDismiss}>
            {text.headers.turnOff}
          </StyledModalHeader>

          <StyledModalBody>
            <ModalMessage>
              <Text>
                {interpolateMessage<"siteName">(
                  text.messages.areYouSureYouWantToTurnOffGatsbyCloudCDN,
                  { siteName }
                )}
              </Text>
            </ModalMessage>

            {errorAlert}

            <StyledModalActions>
              <Button type="button" onClick={onDismiss} variant="SECONDARY">
                {uiText.actions.cancel}
              </Button>
              <Button
                data-testid="remove-cms-integration"
                type="button"
                onClick={handleDisable}
                tone="DANGER"
                variant="PRIMARY"
              >
                {uiText.actions.turnOff}
              </Button>
            </StyledModalActions>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}
